import React from "react";
import { Grid } from "@mui/material";
import {
  ContactMeMainContainer,
  StyledImage,
} from "./StyledContactMeSection";
import MyForm from "./MyForm";
import contactMeImg from "../images/ContactImage.JPG";


function ContactMeSection() {
  

  return (
    <ContactMeMainContainer
      container
      justifyContent="center"
      alignItems="center"
      id="contact-me"
    >
      <Grid container item justifyContent="space-around" alignItems="center">
        <Grid item xs={12} md={4}>
         <MyForm />
        </Grid>
        <Grid container item xs={12} md={4} justifyContent="center" >
          <StyledImage
            src={contactMeImg}
            alt="ContactMeImage"
          ></StyledImage>
        </Grid>
      </Grid>
    </ContactMeMainContainer>
  );
}

export default ContactMeSection;
